import React, { useState, useEffect } from "react";
import { Text, Box, Flex, HStack } from "@chakra-ui/react";

const DataTotalBalance = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiUrl = "https://blindfoldcapital.com/api/total_balance/";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error("Network response was not ok");
        const result = await response.json();
        setData(result.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData(); // ✅ Initial fetch

    const interval = setInterval(fetchData, 120000); // ✅ Fetch every 2 minutes (120,000 ms)

    return () => clearInterval(interval); // ✅ Cleanup on unmount
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const accountTotal = data.filter((entry) => entry.token === "TOTAL");

  const latest = accountTotal.length > 0 ? accountTotal[accountTotal.length - 1] : null;

  if (!latest) {
    return <Text>No balance data available.</Text>;
  }

  return (
    <Flex direction={{ base: "column", md: "row" }} wrap="wrap" justify="center">
      <Box
        fontFamily="Sentinel-light"
        w={{ base: "100%", md: "33.33%" }}
        mb={{ base: 2, md: 0 }}
        px={{ base: 2, md: 3 }}
        mx="auto"
      >
        <HStack w="100%" justify="center">
          <Text fontSize="sm" fontWeight="bold">
            Available
          </Text>
          <Text fontSize="sm">
            ${latest.balance.toFixed(2)} (as of {formatDate(latest.timestamp)})
          </Text>
        </HStack>
      </Box>
    </Flex>
  );
};

export default DataTotalBalance;
